import { agentContentHooks } from '@/manager';
import { DataOverview } from './data-overview'
import { SearchBar } from './search-bar'
import { ContentTableList } from './content-table-list';

/** 智能体内容管理 */
export const AgentDashboardContentManagement = () => {
  const {
    loading,
    contentList,
    searchFormData,
    search,
    changePage,
    resetAndSearch,
    changeSearchForm,
  } = agentContentHooks.useContentListData();

  return (
    <div className='w-full h-full flex flex-col overflow-hidden gap-6'>
      <DataOverview />
      <SearchBar
        searchFormData={searchFormData}
        search={search}
        resetAndSearch={resetAndSearch}
        changeSearchForm={changeSearchForm}
      />
      <ContentTableList
        contentList={contentList}
        loading={loading}
        total={searchFormData.total}
        page={searchFormData.page}
        type={searchFormData.type}
        pageSize={searchFormData.pageSize}
        changePage={changePage}
        search={search}
      />
    </div>
  )
}
